export default {
  tiposFechamento: [],
  tiposDados: [],
  tiposEvento: [],
  processamento: []
};
